import PathNormativitiesMeasureTypeOverlay from "./pathNormativitiesMeasureTypeOverlay/PathNormativitiesMeasureTypeOverlay";
import RoadAccidentsOverlay from "./roadAccidentsOverlay/RoadAccidentsOverlay";
import RoadAccidentSegmentsOverlay from "./roadAccidentSegmentsOverlay/RoadAccidentSegmentsOverlay";
import CustomMapOverlay from "./customMapOverlay/CustomMapOverlay";
import HighwayNetworkSegmentsOverlay from "./highwayNetworkSegmentsOverlay/HighwayNetworkSegmentsOverlay";
import RoadBedLayerSegmentsOverlay from "./roadBedLayerSegmentsOverlay/RoadBedLayerSegmentsOverlay";
import RoadCategorySegmentsOverlay from "./roadCategorySegmentsOverlay/RoadCategorySegmentsOverlay";
import TransportNowOverlay from "./transportNowOverlay/TransportNowOverlay";
import TransportHistoryOverlay from "./transportHistoryOverlay/TransportHistoryOverlay";
import GeoMarkersOverlay from "./geoMarkersOverlay/GeoMarkersOverlay";
import RoadWorksWithNormativitiesOverlay from "./roadWorksWithNormativitiesOverlay/RoadWorksWithNormativitiesOverlay";
import GismeteoPrecipitationOverlay from "./gismeteoPrecipitationOverlay/GismeteoPrecipitationOverlay";
import WaysideLandLotsOverlay from "./waysideLandLotsOverlay/WaysideLandLotsOverlay";
import { useMapURLParams } from "../../../../hooks/map/useMapParams";
import RepairPlanOverlay from "./repairPlanOverlay/RepairPlanOverlay";
import LayersOpacityOverlay from "../layersOpacityOverlay/LayersOpacityOverlay";
import ConfiguredPageLayersLegend from "./configuredPageLayersLegend/ConfiguredPageLayersLegend";

// Компонент - вспомогательное окно для карты 
export function MapOverlayWidget({ mapFilterOptions }: any) {

    const { mapName, mapOption } = useMapURLParams();

    return (
        <>
            {mapName === "HighwayNetworkSegments" && <HighwayNetworkSegmentsOverlay />}
            {mapName === "PathNormativities" && <PathNormativitiesMeasureTypeOverlay measureType={mapOption} />}
            {mapName === "RoadBedLayerSegments" && <RoadBedLayerSegmentsOverlay />}
            {mapName === "RoadCategorySegments" && <RoadCategorySegmentsOverlay />}
            {mapName === "transport" && mapOption === "now" && <TransportNowOverlay />}
            {mapName === "transport" && mapOption === "history" && <TransportHistoryOverlay />}
            {mapName === "RoadAccidents" && <RoadAccidentsOverlay />}
            {mapName === "RoadAccidentSegments" && <RoadAccidentSegmentsOverlay />}
            {mapName === "GeoMarkers" && <GeoMarkersOverlay />}
            {mapName === "gismeteo" && mapOption === "precipitation" && <GismeteoPrecipitationOverlay />}
            {mapName === "RoadWorksWithNormativities" && <RoadWorksWithNormativitiesOverlay />}
            {mapName === "WaysideLandLots" && <WaysideLandLotsOverlay />}
            {mapName === "RepairPlan" && <RepairPlanOverlay />}
            {mapFilterOptions && <CustomMapOverlay filterOptions={mapFilterOptions} mapName={mapName} />}
            <ConfiguredPageLayersLegend />
            <LayersOpacityOverlay />
        </>
    );
}
